<script setup>
import Card from "~/components/ui/Card.vue";
import CalendarIcon from "~/components/public/CalendarIcon.vue";

const route = useRoute();
const publicSiteData = useState('publicSiteData');

const { data: meetings } = await useAsyncData(
    'past-meetings',
    async () => {
        // Wait for publicSiteData if needed
        if (!publicSiteData.value?.organization_id) {
            // On server, this might need to wait for middleware
            if (process.server) {
                // Return empty array and let client fetch
                return [];
            }
        }

        if (publicSiteData.value?.organization_id) {
            try {
                const response = await publicFetch('/public-sites/past-meetings?limit=4');
                return response.data || [];
            } catch (e) {
                return [];
            }
        }
        return [];
    },
    {
        // This will refetch on client if server returned empty
        server: true,
        lazy: false,
        watch: [publicSiteData]
    }
);
</script>

<template>
    <Card>
        <div class="flex flex-col justify-between h-full">
            <div>
                <NuxtLink
                    v-for="meeting in meetings"
                    :key="meeting.id"
                    :to="`/${route.params.site_slug}/meetings/${meeting.slug}`"
                    class="border-b border-gray-400 p-2 text-gray-900 flex gap-4 items-center"
                >
                    <CalendarIcon :date="meeting.start" size="small"></CalendarIcon>
                    <span class="text-sm font-medium">{{ meeting.title }}</span>
                </NuxtLink>
            </div>
            <div class="text-center mt-6 text-sm font-light">
                <NuxtLink :to="`/${route.params.site_slug}/meetings`" class="underline">View all meetings</NuxtLink>
            </div>
        </div>
    </Card>
</template>